<template>
  <div>
    <!-- 首屏轮播 + 导航区(首页比较特殊)-->
    <Banner></Banner>
    <!-- 公司简介 -->
    <company-profile></company-profile>
    <!-- 服务项目 -->
    <service-items></service-items>
    <!-- 客户评价 -->
    <customer-reviews></customer-reviews>
    <!-- 合作伙伴 -->
    <Partnership></Partnership>
  </div>
</template>

<script>
import Partnership from './components/Partnership.vue'
import CustomerReviews from './components/CustomerReviews.vue'
import ServiceItems from './components/ServiceItems.vue'
import CompanyProfile from './components/CompanyProfile.vue'
import Banner from './components/Banner.vue'

export default {
  components:{ Partnership, CustomerReviews,ServiceItems,CompanyProfile,Banner },
}
</script>

<style lang="less" scoped>

</style>